module.exports = __webpack_public_path__ + "static/media/export-grey.577df4db.svg";